// recon-assets-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rca.item.acqCapitalized': '{supplier} — aktivert kjøp',
  'rca.item.acqExpensed': '{supplier} — kostnadsført kjøp',
  'rca.item.acqCapitalizedDesc': '{supplier} — aktivert kjøp ({description})',
  'rca.item.acqExpensedDesc': '{supplier} — kostnadsført kjøp ({description})',
  'rca.item.docMissing': '{name} — kjøpsdokumentasjon mangler',
  'rca.item.noDepreciation': '{name} — ingen avskrivning beregnet for {year}',
  'rca.item.fullyDepreciated': '{name} — fullt avskrevet og fortsatt i registeret',
  'rca.item.negativeValue': '{name} — negativ bokført verdi i registeret',
  'rca.item.depDeviates': '{label} — bokført avskrivning avviker fra registeret',
  'rca.item.depNotBooked': '{label} — årets avskrivning er ikke bokført',
  'rca.item.unregisteredDisposal': '{name} — kreditføring på anleggskonto uten registrert avgang',
  'rca.item.registeredDisposal': '{name} — avgang registrert i perioden',
  'rca.item.directPosting': 'Direkteføring på konto {account}',
  'rca.item.directPostingDesc': 'Direkteføring på konto {account} — {description}',
  'rca.fallback.purchase': 'Kjøp',
  'rca.fallback.creditOnAssetAccount': 'Kreditføring på anleggskonto',
  'rca.src.ledger.label': 'Hovedbok og saldobalanse',
  'rca.src.ledger.detail': 'Til og med {date}',
  'rca.src.register.label': 'Anleggsregister',
  'rca.src.register.detailOne': '{count} eiendel i registeret',
  'rca.src.register.detailMany': '{count} eiendeler i registeret',
  'rca.src.register.detailUnavailable': 'Registeret kunne ikke leses for {year}',
  'rca.src.purchaseDocs.label': 'Kjøpsdokumentasjon for balanseførte eiendeler',
  'rca.src.purchaseDocs.detailOne': '{count} eiendel mangler bilag',
  'rca.src.purchaseDocs.detailMany': '{count} eiendeler mangler bilag',
  'rca.src.purchaseDocs.detailAll': 'Alle registrerte eiendeler har bilag',
  'rca.src.depBasis.label': 'Avskrivningsgrunnlag fra registeret',
  'rca.src.depBasis.detailMissing': '{count} eiendeler uten beregnet avskrivning for {year}',
  'rca.src.depBasis.detailOk': 'Registeret har avskrivning for {year} på alle eiendeler i drift',
  'rca.src.disposalDocs.label': 'Dokumentasjon for avganger',
  'rca.src.disposalDocs.detailMissing': '{count} registrert avgang uten bilag',
  'rca.src.disposalDocs.detailOk': 'Registrerte avganger har bilag',
  'rca.src.disposalDocs.detailNone': 'Ingen avganger i perioden',
  'rca.src.acquisitions.label': 'Leverandørbilag i perioden',
  'rca.src.acquisitions.detail': '{count} kjøp analysert mot aktiveringsgrensen',
  'rca.src.physical.label': 'Dokumentasjon av fysisk kontroll',
  'rca.src.physical.detail': 'Bekrefter at eiendelene finnes. Lastes opp som dokumentasjon på området.',
  'rca.src.insurance.label': 'Forsikrings- og panteoversikt',
  'rca.src.insurance.detail': 'Bekrefter eierskap og heftelser. Lastes opp som dokumentasjon på området.',
  'rca.check.registerVsLedger': 'Anleggsregisteret er sammenliknet med hovedboken',
  'rca.check.accounts': 'Alle anleggskontoer i hovedboken er inkludert',
  'rca.check.additions': 'Tilganger i perioden er analysert',
  'rca.check.additionsInfo': '{count} kjøp',
  'rca.check.disposals': 'Avganger er analysert',
  'rca.check.proceeds': 'Vederlag ved avgang er bokført',
  'rca.check.gain': 'Gevinst og tap ved avgang er beregnet',
  'rca.check.depreciation': 'Bokført avskrivning er sammenliknet med registeret',
  'rca.check.directPostings': 'Direkteføringer på anleggskonto er identifisert',
  'rca.check.capitalization': 'Større kostnadsførte kjøp er analysert',
  'rca.check.negative': 'Negative bokførte verdier er kontrollert',
  'rca.check.fullyDepreciated': 'Fullt avskrevne eiendeler er identifisert',
  'rca.check.documentation': 'Manglende kjøpsdokumentasjon er identifisert',
  'rca.check.noPlan': 'Eiendeler uten beregnet avskrivning er identifisert',
});
